export const CONTENT_SEARCH_MAX_HEIGHT = 170 as const;
